import React from "react"

import { Controller } from 'react-hook-form'

import { bool, object } from "prop-types"

import { useRole } from 'Pods/ItemPage/TopSection/hooks/useTopSectionProps'
import CustomSelect from "Pods/Shared/CustomSelect/CustomSelect"

import { MATERIAL_OPTIONS, PRINT_RESULT_OPTIONS } from "../../../../Utils/Data"

function MaterialAndResultForm({
  control,
  userHavePermissions,
}) {
  const role = useRole()
  return (
    <>
      <div className="use-cases-area__select-container use-cases-area__form-column">
        <span className="use-cases-area__label cgt-body-base-semibold cgt-mb-4">
          Material
        </span>
        <Controller
          name="material"
          control={control}
          render={({ field }) => (
            <CustomSelect
              {...field}
              options={MATERIAL_OPTIONS}
              placeholder="Select material"
              isDisabled={!userHavePermissions}
              className="use-cases-area__select cgt-body-base-semibold"
              isClearable
            />
          )}
        />
      </div>

      {role !== 'seller' && (
        <div
          className="use-cases-area__select-container use-cases-area__form-column"
          style={{ flexBasis: '100%' }}
        >
          <span className="use-cases-area__label cgt-body-base-semibold cgt-mb-4">
            How did your print turn out?
          </span>
          <Controller
            name="printSuccess"
            control={control}
            render={({ field }) => (
              <CustomSelect
                {...field}
                options={PRINT_RESULT_OPTIONS}
                placeholder="Select result"
                isDisabled={!userHavePermissions}
                className="use-cases-area__select cgt-body-base-semibold"
                isClearable={false}
              />
            )}
          />
        </div>
      )}
    </>
  )
}

MaterialAndResultForm.propTypes = {
  control: object.isRequired,
  userHavePermissions: bool.isRequired,
}

export default MaterialAndResultForm
